export default {
  ENABLE_CUSTOM_API: false,
};
